import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "subTitle", "icon", "tabItemWeight", "tabContext"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Tabs/src/TabItem.js",
    _this = this;
/* stylelint-disable */


import PropTypes from 'prop-types';
import React, { useRef, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { testIdProps } from '../../../helpers';
import { scrollElement } from '../../../helpers/smoothScrollingPolyfill';
import { TabBottomBorder } from './TabBar';
import { withTheme } from '../../../core/ThemeProvider';
import Text from '../../Text';

var TabItem = function TabItem(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      icon = _ref.icon,
      tabItemWeight = _ref.tabItemWeight,
      tabContext = _ref.tabContext,
      rest = _objectWithoutProperties(_ref, _excluded);

  var containerRef = useRef();
  var hasIcon = !!icon;
  var showSubtitle = subTitle && !hasIcon;
  var showIcon = hasIcon && !subTitle;
  /* Props from tab context */

  var _ref2 = tabContext || {},
      index = _ref2.index,
      isSelected = _ref2.isSelected,
      onItemClick = _ref2.onItemClick,
      isMobile = _ref2.isMobile,
      windowSize = _ref2.windowSize,
      indicatorEl = _ref2.indicatorEl,
      tabsContainerEl = _ref2.tabsContainerEl,
      secondary = _ref2.secondary;

  var animateTabIndicator = function animateTabIndicator(selectedTab) {
    indicatorEl.style.width = "".concat(selectedTab.offsetWidth, "px");
    indicatorEl.style.left = "".concat(selectedTab.offsetLeft, "px");
    indicatorEl.style.transition = 'width 0.3s, left 0.3s';
  };

  var scrollToSelectedTabIfNeeded = function scrollToSelectedTabIfNeeded(selectedTab) {
    var containerWidth = tabsContainerEl.offsetWidth;
    var selectedTabLeft = selectedTab.getBoundingClientRect().left;
    var selectedTabWidth = selectedTab.offsetWidth;
    var arrowPadding = isMobile ? 0 : 20;

    if (selectedTabLeft < 0) {
      scrollElement(tabsContainerEl, {
        left: selectedTab.offsetLeft - arrowPadding,
        behavior: 'smooth'
      });
    } else if (containerWidth < selectedTabLeft + selectedTabWidth) {
      scrollElement(tabsContainerEl, {
        top: 0,
        left: selectedTab.offsetLeft + selectedTabWidth - containerWidth + arrowPadding,
        behavior: 'smooth'
      });
    }
  };

  var onClick = function onClick(e) {
    onItemClick && onItemClick(e, index);
  };

  useEffect(function () {
    if (isSelected) {
      indicatorEl && containerRef.current && animateTabIndicator(containerRef.current);
      tabsContainerEl && containerRef.current && scrollToSelectedTabIfNeeded(containerRef.current);
    }
  }, [indicatorEl, isSelected, containerRef, windowSize]);
  return /*#__PURE__*/React.createElement(TabItemContainer, _extends({
    isSelected: isSelected,
    onClick: onClick,
    tabItemWeight: tabItemWeight,
    ref: containerRef,
    secondary: secondary
  }, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(TabItemBottomBorder, {
    secondary: secondary,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 7
    }
  }), showIcon && /*#__PURE__*/React.createElement(TabIconContainer, {
    "data-testid": 'tabItemIcon',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(TabIcon, {
    isSelected: isSelected,
    icon: icon,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 11
    }
  })), title && /*#__PURE__*/React.createElement(TabItemTitle, {
    type: isSelected ? 'boldBody' : 'body',
    isSelected: isSelected,
    lineHeight: "compact",
    "data-text": title,
    "data-testid": isSelected ? 'tabItemTitleSelected' : 'tabItemTitle',
    secondary: secondary,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 9
    }
  }, title), showSubtitle && /*#__PURE__*/React.createElement(TabItemSubTitle, {
    isSelected: isSelected,
    type: "smallBody",
    lineHeight: "compact",
    "data-testid": 'tabItemSubTitle',
    secondary: secondary,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 9
    }
  }, subTitle));
};

export var TabItemPropTypes = {
  icon: PropTypes.node,

  /**
   * Deprecated: icon name
   */
  iconName: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string
};
export default TabItem;
var TabItemBottomBorder = withTheme(styled(TabBottomBorder).withConfig({
  displayName: "TabItem__TabItemBottomBorder",
  componentId: "sc-198jj6o-0"
})(function (_ref3) {
  var _coreTheme$tab$second;

  var coreTheme = _ref3.coreTheme,
      secondary = _ref3.secondary;
  return css(["background-color:", ";", ""], coreTheme.tab.bottomBorderColor, secondary && css(["background-color:", ";"], (_coreTheme$tab$second = coreTheme.tab.secondary) === null || _coreTheme$tab$second === void 0 ? void 0 : _coreTheme$tab$second.bottomBorderColor));
}));
var TabItemTitle = withTheme(styled(Text).withConfig({
  displayName: "TabItem__TabItemTitle",
  componentId: "sc-198jj6o-1"
})(function (_ref4) {
  var _coreTheme$tab$second2, _coreTheme$tab$second3;

  var coreTheme = _ref4.coreTheme,
      isSelected = _ref4.isSelected,
      secondary = _ref4.secondary;
  return css(["width:100%;overflow:hidden;text-overflow:ellipsis;text-align:center;font-size:", ";font-weight:", ";font-family:", ";color:", ";::after{display:block;height:1px;content:attr(data-text);visibility:hidden;overflow:hidden;}", ""], coreTheme.tab.fontSize, coreTheme.tab.fontWeight, coreTheme.tab.fontFamily, isSelected ? coreTheme.tab.selectedTabTitleColor : coreTheme.tab.tabTitleColor, secondary && css(["color:", ";"], isSelected ? (_coreTheme$tab$second2 = coreTheme.tab.secondary) === null || _coreTheme$tab$second2 === void 0 ? void 0 : _coreTheme$tab$second2.selectedTabTitleColor : (_coreTheme$tab$second3 = coreTheme.tab.secondary) === null || _coreTheme$tab$second3 === void 0 ? void 0 : _coreTheme$tab$second3.tabTitleColor));
}));
var TabItemSubTitle = withTheme(styled(Text).withConfig({
  displayName: "TabItem__TabItemSubTitle",
  componentId: "sc-198jj6o-2"
})(function (_ref5) {
  var _coreTheme$tab$second4, _coreTheme$tab$second5;

  var coreTheme = _ref5.coreTheme,
      isSelected = _ref5.isSelected,
      secondary = _ref5.secondary;
  return css(["width:100%;overflow:hidden;text-overflow:ellipsis;text-align:center;font-size:", ";font-weight:", ";font-family:", ";margin-top:2px;color:", ";", ""], coreTheme.tab.fontSize, coreTheme.tab.fontWeight, coreTheme.tab.fontFamily, isSelected ? coreTheme.tab.selectedTabTitleColor : coreTheme.tab.tabTitleColor, secondary && coreTheme.tab.secondary && css(["color:", ";"], isSelected ? (_coreTheme$tab$second4 = coreTheme.tab.secondary) === null || _coreTheme$tab$second4 === void 0 ? void 0 : _coreTheme$tab$second4.selectedTabTitleColor : (_coreTheme$tab$second5 = coreTheme.tab.secondary) === null || _coreTheme$tab$second5 === void 0 ? void 0 : _coreTheme$tab$second5.tabTitleColor));
}));
var TabItemContainer = withTheme(styled.div.withConfig({
  displayName: "TabItem__TabItemContainer",
  componentId: "sc-198jj6o-3"
})(function (_ref6) {
  var _coreTheme$tab$second6, _coreTheme$tab$second7, _coreTheme$tab$second8, _coreTheme$tab$second9, _coreTheme$tab$second10;

  var coreTheme = _ref6.coreTheme,
      isSelected = _ref6.isSelected,
      tabItemWeight = _ref6.tabItemWeight,
      secondary = _ref6.secondary;
  return css(["position:relative;min-height:", ";min-width:", ";box-sizing:border-box;padding:", ";white-space:nowrap;display:table-cell;transition:background 0.2s ease-out;cursor:pointer;user-select:none;width:'", "%';background-color:", ";", " &:hover{background-color:", ";", "}:first-child{border-top-left-radius:", ";border-bottom-left-radius:", ";}:last-child{border-top-right-radius:", ";border-bottom-right-radius:", ";}", ";", " ", ""], coreTheme.tab.tabItemMinHeight ? coreTheme.tab.tabItemMinHeight : '48px', coreTheme.tab.tabItemMinWidth, coreTheme.tab.tabItemContainerPadding, tabItemWeight, isSelected ? coreTheme.tab.tabItemContainerActiveBg : coreTheme.tab.tabItemContainerBg, secondary && css(["background-color:", ";"], (_coreTheme$tab$second6 = coreTheme.tab.secondary) === null || _coreTheme$tab$second6 === void 0 ? void 0 : _coreTheme$tab$second6.tabItemContainerBg), coreTheme.tab.tabItemContainerHoverBg, secondary && css(["background-color:", ";"], (_coreTheme$tab$second7 = coreTheme.tab.secondary) === null || _coreTheme$tab$second7 === void 0 ? void 0 : _coreTheme$tab$second7.tabItemContainerHoverBg), coreTheme.tab.borderRadius, coreTheme.tab.borderRadius, coreTheme.tab.borderRadius, coreTheme.tab.borderRadius, isSelected === true && coreTheme.tab.afterTriangleColor && css(["::after{position:absolute;content:'';width:0px;height:0px;border-top:15px solid ", ";border-right:15px solid transparent;border-bottom:15px solid transparent;border-left:15px solid transparent;left:50%;margin-left:-15px;top:95%;z-index:9;}"], coreTheme.tab.afterTriangleColor), secondary && coreTheme.tab.secondary && css(["background-color:", ";"], isSelected ? (_coreTheme$tab$second8 = coreTheme.tab.secondary) === null || _coreTheme$tab$second8 === void 0 ? void 0 : _coreTheme$tab$second8.tabItemContainerActiveBg : (_coreTheme$tab$second9 = coreTheme.tab.secondary) === null || _coreTheme$tab$second9 === void 0 ? void 0 : _coreTheme$tab$second9.tabItemContainerBg), secondary && isSelected === true && coreTheme.tab.secondary && css(["::after{border-top:15px solid ", ";}"], (_coreTheme$tab$second10 = coreTheme.tab.secondary) === null || _coreTheme$tab$second10 === void 0 ? void 0 : _coreTheme$tab$second10.afterTriangleColor));
}));
var TabIcon = withTheme(function (_ref7) {
  var isSelected = _ref7.isSelected,
      Icon = _ref7.icon,
      coreTheme = _ref7.coreTheme;
  return /*#__PURE__*/React.createElement(Icon, {
    size: 24,
    color: isSelected ? coreTheme.cl_sec_d1 : coreTheme.cl_ter_base,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 287,
      columnNumber: 3
    }
  });
});
var TabIconContainer = styled.div.withConfig({
  displayName: "TabItem__TabIconContainer",
  componentId: "sc-198jj6o-4"
})(["text-align:center;margin-bottom:8px;"]);